import React from 'react'
import './nav.css'
import {BiHomeSmile, BiBook} from 'react-icons/bi'
import {AiOutlineUser} from 'react-icons/ai'
import {MdOutlineDesignServices} from 'react-icons/md'
import {TbMessageCircle} from 'react-icons/tb'
import { useState } from 'react'

const Nav = () => {
  const [activeNav,setActiveNav] = useState('#');
  return (
    <nav>
      {/* eslint-disable-next-line */}
      <a href="#" onClick={()=>{setActiveNav('#')}} className={activeNav ==='#'? 'active':''}><BiHomeSmile /></a>
      <a href="#about" onClick={()=>{setActiveNav('#about')}} className={activeNav ==='#about'? 'active':''}><AiOutlineUser /></a>
      <a href="#experience" onClick={()=>{setActiveNav('#experience')}} className={activeNav ==='#experience'? 'active':''}><BiBook /></a>
      <a href="#services" onClick={()=>{setActiveNav('#services')}} className={activeNav ==='#services'? 'active':''}><MdOutlineDesignServices /></a>
      <a href="#contact" onClick={()=>{setActiveNav('#contact')}} className={activeNav ==='#contact'? 'active':''}><TbMessageCircle /></a>
    </nav>
  )
}

export default Nav